/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconCompleteContract/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconCompleteContract({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconCompleteContract",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 20,
  height = 20,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#55AAD4"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconCompleteContract.Svg"
  data-view-path={viewPath}
 viewBox="0 0 20 20"
 style={{'--as-1-ZUimES': alignSelf,'--mt-2-ZUimES': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZUimES': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZUimES': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZUimES': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZUimES': opacity,'--w-10-ZUimES': typeof width === 'number' ? `${width}px` : width,'--h-11-ZUimES': typeof height === 'number' ? `${height}px` : height,'--f-12-ZUimES': fill,'--a-7-ZUimES': isAnimated ? animation : "none",'--sd-8-ZUimES': isAnimated ? strokeDashoffset : 0,'--sd-9-ZUimES': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconCompleteContract.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M12.726 3.13a.446.446 0 00-.631.001L6.398 8.836a.446.446 0 00-.126.254l-.268 1.901a.446.446 0 00.503.505l1.901-.259a.447.447 0 00.256-.127l5.705-5.705a.446.446 0 000-.631L12.726 3.13zM5.47 8H4.5A1.5 1.5 0 003 9.5v6A1.5 1.5 0 004.5 17h11a1.5 1.5 0 001.5-1.5v-6A1.5 1.5 0 0015.5 8h-1.958l-3.994 3.994a1.697 1.697 0 01-.97.482l-1.903.258a1.696 1.696 0 01-1.908-1.917l.267-1.902c.049-.342.2-.662.435-.915zM12 11.375a.625.625 0 100 1.25h2.5a.625.625 0 100-1.25H12zm-3 2.5a.625.625 0 100 1.25h5.5a.625.625 0 100-1.25H9z"
 style={{'--f-12-ZUimES': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}